module.exports = __webpack_public_path__ + "img/ai-launcher-green.7dcea9d8.svg";